import { render, staticRenderFns } from "./card-pax.vue?vue&type=template&id=e1037c58&scoped=true"
import script from "./card-pax.vue?vue&type=script&lang=js"
export * from "./card-pax.vue?vue&type=script&lang=js"
import style0 from "./card-pax.vue?vue&type=style&index=0&id=e1037c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1037c58",
  null
  
)

export default component.exports